import React from "react";
import "../../Stylesheets/index.css";

const TableBody = ({tableBodyArr, option, errorText = "No Data available"}) => {

    const getTableRowCol = (colsArr, rowIndex) => {
        return colsArr.map((col, colIndex) => {
            return <td key={colIndex}>{col}</td>;
        });
    }

    const getTableBodyRows = () => {
        if (tableBodyArr === null || tableBodyArr.length === 0) {
            return (
                <tr>
                    <td colSpan="100" className="text-center border-top">{errorText}</td>
                </tr>
            );
        }

        return tableBodyArr.map((row, rowIndex) => {
            let classNames = "border-top";
            if (option?.firstChildHighlight && rowIndex === 0) {
                classNames += " fw-bold";
            }
            return (
                <tr key={rowIndex} className={classNames}>
                    {getTableRowCol(row, rowIndex)}
                </tr>
            )
        });
    }

    return (
        <tbody>
        {getTableBodyRows()}
        </tbody>
    )
}

export default TableBody;
